module.exports = __webpack_public_path__ + "static/media/robot_normal.d3ee5081.png";